import { NgModule } from '@angular/core';
import {Routes, RouterModule } from '@angular/router';
import {CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule } from "@angular/forms";

import {RxFormsModule} from "@rx/forms";
import {RxViewModule} from "@rx/view";
import {    RxTableModule} from "@rx/table";

import { UserProfileComponent } from './user-profile.component'
import { USER_PROFILE_ROUTING } from './user-profile.routing'
import {UsersService } from "../users.service";
import { UserProfilePhotoSharedComponentModule } from '../../../shared/user-profile-photo/app-user-profile-photo-shared-component.module';

@NgModule({
    imports: [
        USER_PROFILE_ROUTING ,
        CommonModule, RxViewModule, RxTableModule, RxFormsModule, FormsModule, ReactiveFormsModule,UserProfilePhotoSharedComponentModule
		    ],
    declarations: [UserProfileComponent ],
    exports: [RouterModule],
    providers: [UsersService]
})
export class UserProfileModule { }